import type { ComponentType } from 'react';

import type { SliderHelpers } from '../..';

import { ScSlideGridContainer } from './styled';

export interface SliderChunk<T> {
  itemsGroup: T[];
  rows: number;
  cols: number;
}

export interface SlideGridContainerProps<T> extends SliderChunk<T> {
  itemComponent: ComponentType<T>;
  sliderHelpers: SliderHelpers;
}

export function SlideGridContainer<T>({
  itemsGroup,
  itemComponent: Item,
  sliderHelpers,
  rows,
  cols,
}: SlideGridContainerProps<T>) {
  return (
    <ScSlideGridContainer cols={cols} rows={rows}>
      {itemsGroup.map((item, i) => (
        <Item {...item} {...sliderHelpers} key={i} />
      ))}
    </ScSlideGridContainer>
  );
}
